import { Box, Text } from "@chakra-ui/react";

import AgentTicketsPerServiceTable from "../../tables/daily/AgentTicketsPerServiceTable";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildTicketVolumeInsights } from "../../../../store/reportEnterpriseInsights";

const BranchAgentTicketsPerService = ({ reportIndex, data, renderConfig }) => {
  return (
    <Box>
      {data.map(({ branchName, servicesData, numServices }, branchIndex) => {
        const title = `${reportIndex || ""}.${branchIndex + 1}. ${branchName}`;
        const insights = buildTicketVolumeInsights(
          { branchName, servicesData },
          { scopeLabel: "Agent" }
        );
        return (
          <>
            <h2>{title}</h2>
            <Text>{numServices} services.</Text>
            <EnterpriseReportSummary
              title="Daily Agent Ticket Mix Summary"
              kpis={insights.kpis}
              tables={insights.tables}
              notes={insights.notes}
            />
            {servicesData.map((data, index) => {
              return (
                <AgentTicketsPerServiceTable
                  key={index}
                  index={index}
                  serviceData={data}
                  branchIndex={branchIndex}
                  reportIndex={reportIndex}
                  branchName={branchName}
                  renderConfig={renderConfig}
                />
              );
            })}
          </>
        );
      })}
    </Box>
  );
};

export default BranchAgentTicketsPerService;
